import React, { HTMLAttributes, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Modal } from "antd";
import { Hooks } from "@xt/xtbase";
//import store from "store";
import styles from "./index.module.less";
import SvgIcon from "@xt/SvgIcon";
import { VerifyDataProps } from "..";
import certificationSvg from "@/assets/icon-svg/shimingrenzhengrenzheng.svg";
import verifiedSvg from "@/assets/icon-svg/shenhebutongguo.svg";
import otcremindicored2 from "@/assets/icon-svg/otc_remind_ico_red2.svg";
interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
  verifyData: VerifyDataProps;
  visible: boolean;
  onCloseModal?(): void;
}
const { useTranslation, Trans } = Hooks;
const VerifyDialog: React.FC<Props> = ({ className, verifyData, visible, onCloseModal }) => {
  const t = useTranslation();
  const [isLegal, setIsLegal] = useState(true);
  useEffect(() => {
    if (visible) {
      setIsLegal(verifyData.officialChannel);
    }
  }, [visible]);

  return (
    <Modal
      className={cx(styles["app-modal-verify"])}
      width={500}
      visible={visible}
      footer={null}
      onCancel={() => {
        onCloseModal && onCloseModal();
      }}
    >
      <div className={cx(styles["verify-container"])}>
        <div className={cx(styles["header"])}>
          <SvgIcon src={isLegal ? certificationSvg : verifiedSvg} style={{ width: "22px", color: !isLegal && "#fa5d54" }}></SvgIcon>
          <span>{isLegal ? t("verify.verifyDomain") : t("verifyNoDomain")}</span>
        </div>
        <div className={cx(styles["content"])}>
          {isLegal ? (
            <Trans
              i18nKey="verify.verifyYes"
              values={{ content: verifyData.channel, channelName: verifyData.channelName }}
              components={{ 1: <span key={1} id="channel"></span>, 2: <span key={2} id="channelName"></span> }}
            />
          ) : (
            <Trans i18nKey="verify.verifyNo" values={{ content: verifyData.keyWords }} components={{ 1: <span key={1} id="channel"></span> }} />
          )}
        </div>
        <div className={cx(styles["notice"])}>
          <SvgIcon src={otcremindicored2} style={{ height: "30px", color: "#B9F78A", marginRight: "10px", transform: "translateY(-4px)" }}></SvgIcon>
          <span> {t("verify.verifyNotice")} </span>
        </div>
        <div
          className={cx(styles["btn"])}
          onClick={() => {
            onCloseModal && onCloseModal();
          }}
        >
          {t("verify.gotIt")}
        </div>
      </div>
    </Modal>
  );
};
export default observer(VerifyDialog);
